import { MOCK_HOSTAPP } from 'src/modules/constants';
import { ModulesList } from 'src/modules/types';
import MockHostAppContainer from './index';

const module: ModulesList = {
  [MOCK_HOSTAPP]: {
    component: MockHostAppContainer,
  },
};

export default module;
